import firebase from '../firebase';

import { get, getFile, post } from '../utils/api';
import urls from '../constants/urls';

const getContext = async (getState) => {
  const state = getState();
  const tenantId = state?.tenant?.currentTenant?.id;
  const idToken = await firebase.auth.currentUser.getIdToken();

  if (!tenantId) {
    throw new Error('Invalid tenant');
  }

  return { tenantId, idToken };
};

export const createStatusReportJob = (period) => async (dispatch, getState) => {
  const { tenantId, idToken } = await getContext(getState);
  return post(urls.cases.createStatusReport(tenantId), { period }, idToken);
};

export const getStatusReportJob = (jobId) => async (dispatch, getState) => {
  const { tenantId, idToken } = await getContext(getState);
  return get(urls.cases.getStatusReportJob(jobId, tenantId), idToken);
};

export const getStatusReportResult = (jobId) => async (dispatch, getState) => {
  const { tenantId, idToken } = await getContext(getState);
  return get(urls.cases.getStatusReportResult(jobId, tenantId), idToken);
};

export const downloadStatusReport = (jobId, fileName) => async (dispatch, getState) => {
  const { tenantId, idToken } = await getContext(getState);
  const safeName = (fileName || 'Status Report.pdf').replace(/\.pdf$/i, '');
  return getFile(urls.cases.downloadStatusReport(jobId, tenantId), idToken, safeName, 'pdf');
};
